const baseURL: string = "franchisee-dashboard";
export const DashboardEndpoint = {
  twoWeekConsecutiveAbsent: `${baseURL}/getTwoWeekConsecutiveAbsent`,
  dashboardBirthDay: `${baseURL}/todayBirthDay`,
  leadUpdateTracker: `${baseURL}/leadUpdateTracker`,
  getNewAdmissionAndDropOut: `${baseURL}/getNewAdmissionAndDropOut`,
  getSMSConsumeAndBalance: `${baseURL}/getSMSConsumeAndBalance`,
  getTodayLeadDetails: `${baseURL}/getTodayLeadDetails`,
  getAllActiveStudent: `${baseURL}/getAllActiveStudent`,
  getCertificateInfo: `${baseURL}/getCertificateInfo`,
  netStudentVsReceipts: `${baseURL}/getNetStudentVsReceipts`,
  significantImpact: `${baseURL}/significantImpact`,
  popNotDoneStudentList: `${baseURL}/popNotDoneStudentList`,
  updatePopDone: `${baseURL}/updatePopDone`,
  feedback: "feedback/franchiseeFeedbackList",
  sendBirthdaySMS: `${baseURL}/sendBirthdaySMS`,
  submitFeedback: "feedback/submitFeedback",
};
